<template>
  <VaLayout :top="{ fixed: true, order: 2 }" :left="{
    fixed: true,
    absolute: isMobile,
    order: 1,
    overlay: isMobile && !isSidebarMinimized
  }" @leftOverlayClick="isSidebarMinimized = true">
    <!-- 🔝 Top navbar + tabs + alert -->
    <template #top>
      <AppNavbar :is-mobile="isMobile" :bottom="{ fixed: true, absolute: true }" />
      <TopTabsNavigation class="px-4" />



      <!--  chat solo en móvil -->
      <transition name="fade">
        <div v-if="isMobile && showChat"
          class="px-8 rounded-[50px] w-[95%] mx-auto flex-grow min-w-[300px] max-w-[100%] overflow-hidden">
          
        </div>
      </transition>
    </template>

    <!-- 🔽 Contenido principal -->
    <template #content>
      <main class="pt-0 pb-4">
        <article class="w-[90%] max-w-[1320px] mx-auto">
          <RouterView />
        </article>
      </main>
    </template>
  </VaLayout>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, onBeforeMount } from 'vue'
import { storeToRefs } from 'pinia'
import { onBeforeRouteUpdate } from 'vue-router'

import { useGlobalStore } from '../stores/global-store'

import AppNavbar from '../components/navbar/AppNavbar.vue'
import TopTabsNavigation from '../components/top-tabs-navegation/TopTabsNavigation.vue'
import Chat from '../pages/chat/Chat.vue'

// Store y settings
const GlobalStore = useGlobalStore()
const { isSidebarMinimized } = storeToRefs(GlobalStore)

// Variables de estado
const width = ref(window.innerWidth)
const isMobile = ref(false)
const isDesktop = ref(false)

const sidebarWidth = ref('16rem')
const sidebarMinimizedWidth = ref(undefined)

const isAlertClosed = ref(false)
const showChat = ref(true)

function handleScroll() {
  const currentScroll = window.scrollY

  if (currentScroll <= 100) {
    // Solo mostrar si está casi en la parte superior
    showChat.value = true
  } else {
    showChat.value = false
  }
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
// Función principal de detección de tamaño
function checkWidth() {
  width.value = window.innerWidth
  isMobile.value = width.value <= 820
  isDesktop.value = width.value > 820

  // Ajustes de sidebar
  isSidebarMinimized.value = isMobile.value
  sidebarMinimizedWidth.value = isMobile.value ? '0' : '4.5rem'
}

onMounted(() => {
  checkWidth()
  window.addEventListener('resize', checkWidth)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkWidth)
})


onBeforeRouteUpdate(() => {
  isSidebarMinimized.value = true
  isAlertClosed.value = false
})

const isFullScreenSidebar = computed(() => isSidebarMinimized.value)

const onCloseSidebarButtonClick = () => {
  isSidebarMinimized.value = true
}
</script>


<style lang="scss" scoped>
// Prevent icon jump on animation
.va-sidebar {
  width: unset !important;
  min-width: unset !important;
}

.info-label {
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
  color: #f3fff3;
}

.custom-alert {
  position: fixed;
  /* mejor que absolute para elementos flotantes en pantalla */
  top: 9rem;
  /* La separa 10 rem (160px aprox.) desde la parte superior del contenedor/pantalla */
  right: 1rem;
  left: auto;
  background-color: rgba(64, 107, 112, 0.7) !important;
  z-index: 1000;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}



/* En pantallas grandes, limita el ancho y alinea a la derecha */
@media (min-width: 768px) {
  .custom-alert {
    left: auto;
    right: 4rem;
  }
}
</style>